var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1626_191038",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_1626_191038)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1626_191038)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.7998,
    y: -4.7998,
    width: 20,
    height: 20,
    fill: "#292929",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1626_191038",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1626_191038",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1626_191038",
    width: 60,
    height: 60,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAPKADAAQAAAABAAAAPAAAAACL3+lcAAACEUlEQVRoBe2aMS9EQRDHjygUFHqJTqdRidBp1MTH0KrkjUJoFApapcon0EnEJ9ATiZ5GJec/iUlezrt9u3tzd2/WTPLP3r2dN5nfzO4+D72em1fAK+AV8Ap4BbQqcIBAj9AH9AydQvNQkVaBqt+gB1xbKI2YGkDr8Nz1xVKg22AFvAjoWNgioFNhBZr39NCDbBaTpdk2gI6tQh0hcelcysiPLLNGyDwFln0/zdL+Jk4YU6D5xO60EbJjhYwwGQu9Hwo07bk6CH8OGWGyDboKBZj2XBPAeUtSoYPMHKx0LwfaLGwOtHlYgeYlHzLCJKuzRshMYGLHtuVdFKwUxRx0TmcFVkYz0BqwatDjflti2ArSsi+tQOOIQwgqndEYNQunzuuwI3TbO6u+HjMD+jL2ZRx3avuezdxi6rf5nvU963v2z4+aEz+gUl4elrFkv6F7SMNOEIRlwvgX3f0RRCYoa0ne/CdY5r7MBCa+2aIRkk5d0hM/oDQLe5gIzAUybZvIPrbD1CXSmZZk1jC/B1GD3waurUNLEP8HDWsV2oHE+LFD8sXCeIYkuZOUkOxTxj0J4cfnyt1/gWTpEj7H2AWcKMaxaz5bSEhgZYwBWekaSGw+1w3ADG7mLwCxoOL3PgSYoUmcrI1zgYT5RWHQXnHhFrobnCjh+y4g3iDu9BXEe7rtMQYXN6+AV8Ar4BXwCuRW4AeEP0/RSlsDlAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.6cefac1b5101c0ca608e6ae52a77444a.svg";
export { ForwardRef as ReactComponent };